import React from 'react';
import { useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { Button } from 'antd';
import { DateDisplay, EmailAddress, ProTable, Link } from 'components/layout';
import { GET_EMAIL_LOGS } from 'gql/emailLogs';
import { getEmailAddressTitleForRecipient } from 'utils';

const defaultPageSize = 20;
const ENUM_SORT_ORDER = {
  ascend: 'asc',
  descend: 'desc',
};
// array from 1 to 32
const enumArray = Array.from({ length: 32 }, (_, i) => i + 1);
const valueEnum = enumArray.reduce((prev, i) => {
  prev[i] = i;
  return prev;
}, {});

const Content = ({ item }) => {
  const title = getEmailAddressTitleForRecipient(item);
  return (
    <EmailAddress
      netId={item.user.netId}
      email={item.user.email}
      title={title}
    />
  );
};

const EmailLogs = () => {
  const { data, loading, refetch } = useQuery(GET_EMAIL_LOGS, {
    variables: {
      pageSize: 1,
      current: 1,
    },
  });
  const columns = [
    {
      title: 'Email ID',
      key: 'emailId',
      valueEnum,
      render: (_, record) => record?.emailTemplate?.emailId,
    },
    {
      title: 'Subject',
      dataIndex: ['emailTemplate', 'subject'],
      hideInSearch: true,
    },
    {
      title: 'To',
      dataIndex: 'id',
      hideInSearch: true,
      render: (_, record) => (
        <>
          {record?.to?.map((item) => {
            return (
              <div key={item.id}>
                <Content item={item} />
              </div>
            );
          })}
        </>
      ),
    },
    {
      title: 'Cc',
      hideInSearch: true,
      render: (_, record) => (
        <>
          {record?.cc?.map((item) => {
            return (
              <div key={item.id}>
                <Content item={item} />
              </div>
            );
          })}
        </>
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      sorter: true,
      defaultSortOrder: 'descend',
      hideInSearch: true,
      render: (date) => (
        <DateDisplay date={date} format="YYYY-MM-DD [at] hh:mmA" />
      ),
    },
    {
      title: 'Send At',
      dataIndex: 'updatedAt',
      sorter: true,
      hideInSearch: true,
      render: (date) => (
        <DateDisplay date={date} format="YYYY-MM-DD [at] hh:mmA" />
      ),
    },
    {
      title: 'Actions',
      width: 152,
      hideInSearch: true,
      render: (_, item) => (
        <Link to={`/system-setting/email-logs/${item.id}`}>
          <Button type="primary">View</Button>
        </Link>
      ),
    },
  ];
  return (
    <PageContainer
      loading={loading}
      header={{
        title: 'Email Logs',
      }}
    >
      <ProTable
        toolbar={
          {
            // settings: false,
          }
        }
        toolBarRender={false}
        scroll={{ x: 1080 }}
        columns={columns}
        rowKey="id"
        request={async (params, sort) => {
          const result = await refetch({
            pageSize: params.pageSize || defaultPageSize,
            emailId: params.emailId,
            current: params.current || 1,
            sort: {
              by: Object.keys(sort)[0],
              order: ENUM_SORT_ORDER[sort[Object.keys(sort)[0]]],
            },
          });

          return {
            data: result?.data?.emailLogConnection?.nodes,
            total: result?.data?.emailLogConnection?.totalCount,
            success: true,
          };
        }}
        pagination={{
          defaultCurrent: 1,
          defaultPageSize: defaultPageSize,
          total: data?.emailLogConnection?.totalCount,
        }}
      />
    </PageContainer>
  );
};

export default EmailLogs;
